import { render, staticRenderFns } from "./YourProfileFollow.vue?vue&type=template&id=1f3cfd23&"
import script from "./YourProfileFollow.vue?vue&type=script&lang=js&"
export * from "./YourProfileFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports